import Image from "next/image";
import Link from "next/link";
import Seo from "../../components/Seo";
import { useLineQuoteUrl } from "lib/line";

const registrationScope = [
  "จองชื่อบริษัทหรือห้างหุ้นส่วนกับกรมพัฒนาธุรกิจการค้า",
  "จัดเตรียมหนังสือบริคณห์สนธิและเอกสารประกอบการยื่นจดทะเบียน",
  "ยื่นจดทะเบียนจัดตั้งเมื่อข้อมูลและเอกสารครบถ้วน",
  "ประเมินหน้าที่ด้าน VAT ประกันสังคม และบัญชีหลังจัดตั้ง"
];

const addOnServices = [
  "เปลี่ยนแปลงกรรมการ ผู้ถือหุ้น ที่ตั้ง หรือวัตถุประสงค์ของกิจการ",
  "จดทะเบียนภาษีมูลค่าเพิ่มเมื่อกิจการเข้าเงื่อนไข",
  "ขึ้นทะเบียนนายจ้างและประกันสังคม",
  "จัดเตรียมเอกสารสำหรับเริ่มงานบัญชีรายเดือน"
];

const timeline = [
  { label: "รับข้อมูลกิจการ", detail: "ตรวจชื่อกิจการ ผู้ก่อตั้ง กรรมการ ทุนจดทะเบียน ที่ตั้ง และวัตถุประสงค์" },
  { label: "จัดเตรียมเอกสาร", detail: "จองชื่อและส่งรายการเอกสารให้ผู้เกี่ยวข้องตรวจทานและลงนาม" },
  { label: "ยื่นจดทะเบียน", detail: "ดำเนินการยื่นต่อกรมพัฒนาธุรกิจการค้าเมื่อเอกสารครบถ้วน" },
  { label: "แจ้งผลและส่งมอบ", detail: "แจ้งสถานะ ส่งมอบเอกสาร และสรุปรายการที่กิจการต้องดำเนินการต่อ" }
];

const heroImage = {
  src: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1300&q=80",
  alt: "ภาพประกอบการตรวจเอกสารจดทะเบียนธุรกิจ",
  width: 1300,
  height: 975
};

const navigationItems = [
  { id: "scope", label: "สิ่งที่เราจัดการ" },
  { id: "addons", label: "บริการเสริม" },
  { id: "timeline", label: "ไทม์ไลน์ดำเนินการ" },
  { id: "pricing", label: "แพ็กเกจราคา" },
  { id: "deliverables", label: "เอกสารที่ได้รับ" },
  { id: "faq", label: "คำถามที่พบบ่อย" }
];

const pricingPackages = [
  {
    name: "จดทะเบียนธุรกิจ",
    note: "จดทะเบียนบริษัทหรือหจก. สำหรับทุนไม่เกิน 1 ล้านบาท",
    price: "9,500 บาท",
    unit: "ต่อแพ็กเกจ",
    bullets: ["จองชื่อและยื่นจัดตั้ง", "จัดเตรียมเอกสารประกอบ", "แจ้งรายการที่ต้องดำเนินการหลังจดทะเบียน"]
  },
  {
    name: "งานจดทะเบียนเพิ่มเติม",
    note: "สำหรับเปลี่ยนแปลงข้อมูลบริษัทหรือดำเนินการนอกเหนือจากแพ็กเกจเริ่มต้น",
    price: "สอบถามราคา",
    unit: "ตามขอบเขต",
    bullets: ["เปลี่ยนกรรมการหรือผู้ถือหุ้น", "เปลี่ยนที่ตั้งหรือวัตถุประสงค์", "แจ้งเอกสารและค่าใช้จ่ายก่อนเริ่มงาน"]
  },
  {
    name: "หลังจดทะเบียน",
    note: "สำหรับกิจการที่ต้องดำเนินการด้านภาษี ประกันสังคม หรือเริ่มงานบัญชีรายเดือน",
    price: "สอบถามราคา",
    unit: "ตามขอบเขต",
    bullets: ["ประเมินหน้าที่ด้าน VAT", "ขึ้นทะเบียนนายจ้างเมื่อเกี่ยวข้อง", "เตรียมข้อมูลสำหรับเริ่มงานบัญชี"]
  }
];

const faqs = [
  {
    question: "ต้องเตรียมเอกสารอะไรบ้างก่อนเริ่มจดทะเบียน?",
    answer:
      "จำเป็นต้องมีข้อมูลบัตรประชาชน/ทะเบียนบ้านผู้ถือหุ้นและกรรมการ ทุนจดทะเบียน วัตถุประสงค์บริษัท ที่ตั้งสำนักงาน และสัดส่วนหุ้นของแต่ละคน ทีมเราจะส่งเช็กลิสต์และแบบฟอร์มให้กรอกล่วงหน้า"
  },
  {
    question: "ถ้าอยู่ต่างจังหวัดหรือไม่สะดวกเดินทาง สามารถยื่นแทนได้ไหม?",
    answer:
      "ทีมงานจะแจ้งวิธีลงนามและจัดส่งเอกสารตามประเภทงาน บางขั้นตอนอาจดำเนินการด้วยหนังสือมอบอำนาจได้ โดยต้องตรวจเงื่อนไขของหน่วยงานก่อน"
  },
  {
    question: "หลังจดทะเบียนแล้วต้องทำอะไรต่อ?",
    answer:
      "ทีมงานจะสรุปรายการที่เกี่ยวข้อง เช่น การเปิดบัญชีธนาคาร ภาษีมูลค่าเพิ่ม ประกันสังคม และการจัดทำบัญชีรายเดือนตามสถานะของกิจการ"
  }
];

export default function RegistrationServicesPage() {
  const title = "จดทะเบียนบริษัทและห้างหุ้นส่วน เชียงใหม่";
  const lineUrl = useLineQuoteUrl();
  const siteUrl = (process.env.NEXT_PUBLIC_SITE_URL ?? "https://www.kmcpaccounting.com").replace(/\/$/, "");
  const pageUrl = `${siteUrl}/services/registration`;
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "หน้าแรก", item: `${siteUrl}/` },
          { "@type": "ListItem", position: 2, name: "บริการจดทะเบียนธุรกิจ", item: pageUrl }
        ]
      },
      {
        "@type": "Service",
        "@id": `${pageUrl}#service`,
        name: "บริการจดทะเบียนบริษัทและห้างหุ้นส่วน",
        serviceType: "จดทะเบียนจัดตั้งบริษัทและห้างหุ้นส่วน",
        url: pageUrl,
        provider: { "@id": `${siteUrl}/#organization` },
        areaServed: { "@type": "AdministrativeArea", name: "เชียงใหม่" },
        offers: {
          "@type": "Offer",
          price: "9500",
          priceCurrency: "THB",
          description: "ราคาแพ็กเกจเบื้องต้นสำหรับทุนจดทะเบียนไม่เกิน 1 ล้านบาท โดยยืนยันขอบเขตและค่าใช้จ่ายก่อนเริ่มงาน"
        }
      }
    ]
  };

  return (
    <>
      <Seo
        title={title}
        description="บริการจดทะเบียนบริษัทและห้างหุ้นส่วนในเชียงใหม่ ตั้งแต่จองชื่อ จัดเตรียมเอกสาร ยื่นจดทะเบียน และแจ้งขั้นตอนหลังจัดตั้งกิจการ"
        path="/services/registration"
        jsonLd={structuredData}
      />
      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 -z-10">
          <div className="absolute -top-24 -right-20 h-72 w-72 rounded-full bg-brand/15 blur-3xl" />
          <div className="absolute bottom-0 left-0 h-64 w-64 rounded-full bg-gray-200/60 blur-3xl" />
        </div>
        <div className="mx-auto max-w-7xl px-6 pt-14 pb-16 sm:px-8 sm:pt-16 sm:pb-20">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.05fr,0.95fr] lg:gap-12">
            <div className="max-w-3xl">
              <p className="text-sm font-semibold uppercase tracking-widest text-brand">
                งานจดทะเบียนธุรกิจ
              </p>
              <h1 className="mt-4 max-w-3xl text-4xl font-semibold leading-[1.24] text-gray-900 sm:leading-[1.18]">
                จดทะเบียนบริษัทและห้างหุ้นส่วนในเชียงใหม่
              </h1>
              <p className="mt-4 max-w-2xl text-lg leading-8 text-gray-600">
                ทีม KMCP ช่วยจองชื่อ จัดเตรียมเอกสาร และยื่นจดทะเบียนตามข้อมูลที่กิจการยืนยัน
                พร้อมสรุปรายการด้านภาษี ประกันสังคม และบัญชีที่ควรดำเนินการหลังจัดตั้ง
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-4">
                <a href={lineUrl} target="_blank" rel="noreferrer" className="btn-primary">
                  เช็ครายการเอกสารที่ต้องเตรียม
                </a>
                <Link href="/pricing" className="btn-secondary">
                  ดูแพ็กเกจจดทะเบียน
                </Link>
              </div>
            </div>
            <div className="relative">
              <div className="absolute -top-24 right-8 hidden h-56 w-56 rounded-full bg-white/40 blur-3xl lg:block" />
              <div className="absolute -bottom-10 left-0 hidden h-64 w-64 rounded-full bg-brand/20 blur-3xl lg:block" />
              <div className="relative overflow-hidden rounded-[2.5rem] border border-white/60 bg-white/80 shadow-soft">
                <Image
                  src={heroImage.src}
                  alt={heroImage.alt}
                  width={heroImage.width}
                  height={heroImage.height}
                  className="h-full w-full object-cover"
                  priority
                  sizes="(min-width: 1024px) 540px, 92vw"
                />
              </div>
            </div>
          </div>

          <nav className="mt-10 overflow-x-auto" aria-label="สารบัญงานจดทะเบียน">
            <ul className="flex items-center gap-3 pb-2">
              {navigationItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="inline-flex items-center gap-2 rounded-full border border-gray-200 px-5 py-2 text-sm font-semibold text-gray-600 transition hover:border-brand hover:text-brand"
                  >
                    <span className="h-2 w-2 rounded-full bg-brand/60" />
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div id="scope" className="rounded-2xl border border-gray-100 p-6 shadow-soft scroll-mt-32 sm:p-8">
              <h2 className="text-2xl font-semibold text-gray-900">สิ่งที่เราจัดการให้</h2>
              <ul className="mt-6 space-y-3 text-base text-gray-600">
                {registrationScope.map((item) => (
                  <li key={item} className="flex gap-3">
                    <span className="mt-2 h-2 w-2 rounded-full bg-brand" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <a
                href="https://www.dbd.go.th/storage/manual/ae86c29a-bfa5-44b7-b14e-8918810c7eea.pdf"
                target="_blank"
                rel="noreferrer"
                className="mt-5 inline-flex min-h-11 items-center text-sm font-semibold text-gray-900 hover:underline"
              >
                คู่มือจดทะเบียนบริษัทจากกรมพัฒนาธุรกิจการค้า →
              </a>
            </div>
            <div id="addons" className="rounded-2xl border border-gray-100 p-6 shadow-soft scroll-mt-32 sm:p-8">
              <h2 className="text-2xl font-semibold text-gray-900">บริการเสริมที่พร้อมให้คำปรึกษา</h2>
              <ul className="mt-6 space-y-3 text-base text-gray-600">
                {addOnServices.map((item) => (
                  <li key={item} className="flex gap-3">
                    <span className="mt-2 h-2 w-2 rounded-full bg-brand" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div id="timeline" className="mt-12 scroll-mt-28 rounded-2xl bg-gray-50 p-6 sm:p-8">
            <div className="max-w-2xl">
              <h2 className="text-2xl font-semibold text-gray-900">ขั้นตอนการจดทะเบียนกับ KMCP</h2>
              <p className="mt-3 text-base text-gray-600">
                ทีมงานแจ้งข้อมูลที่ต้องเตรียมและสถานะในแต่ละขั้นตอน ส่วนระยะเวลาจริงขึ้นอยู่กับความครบถ้วนของเอกสาร การอนุมัติชื่อ และการพิจารณาของหน่วยงาน
              </p>
            </div>
            <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
              {timeline.map((item) => (
                <div key={item.label} className="rounded-2xl border border-white bg-white p-6 shadow-soft">
                  <span className="text-sm font-semibold text-brand">{item.label}</span>
                  <p className="mt-2 text-base text-gray-600">{item.detail}</p>
                </div>
              ))}
            </div>
          </div>

          <div id="pricing" className="mt-12 scroll-mt-28 rounded-2xl border border-gray-100 bg-white/80 p-6 shadow-soft sm:p-8">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900">แพ็กเกจจดทะเบียน</h2>
                <p className="mt-2 text-base text-gray-600">
                  ราคาแตกต่างตามประเภทนิติบุคคล ทุนจดทะเบียน โครงสร้างผู้ถือหุ้น และงานหลังจดทะเบียน
                </p>
              </div>
              <Link href="/pricing" className="btn-secondary">
                ดูแพ็กเกจทั้งหมด
              </Link>
            </div>
            <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
              {pricingPackages.map((pkg) => (
                <div key={pkg.name} className="flex h-full flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-soft sm:p-6">
                  <div>
                    <p className="text-sm font-semibold uppercase tracking-wide text-brand">{pkg.name}</p>
                    <p className="mt-1 text-sm text-gray-500">{pkg.note}</p>
                  </div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-3xl font-semibold text-gray-900">{pkg.price}</span>
                    <span className="text-sm text-gray-500">{pkg.unit}</span>
                  </div>
                  <ul className="space-y-2 text-sm text-gray-600">
                    {pkg.bullets.map((bullet) => (
                      <li key={bullet} className="flex items-start gap-2">
                        <span className="mt-1 inline-flex h-2 w-2 flex-shrink-0 rounded-full bg-brand" />
                        <span>{bullet}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href={lineUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-brand"
                  >
                    นัดคุยรายละเอียด
                    <span aria-hidden>→</span>
                  </a>
                </div>
              ))}
            </div>
          </div>

          <div id="deliverables" className="mt-12 grid gap-8 lg:grid-cols-[1.6fr_1fr] scroll-mt-28">
            <div className="rounded-2xl border border-gray-100 p-6 shadow-soft sm:p-8">
              <h2 className="text-2xl font-semibold text-gray-900">เอกสารที่ลูกค้าจะได้รับ</h2>
              <ul className="mt-6 space-y-3 text-base text-gray-600">
                <li className="flex gap-3">
                  <span className="mt-2 h-2 w-2 rounded-full bg-brand" />
                  <span>หนังสือรับรองบริษัท หนังสือบริคณห์สนธิ และวัตถุประสงค์ที่จดทะเบียนกับ DBD</span>
                </li>
                <li className="flex gap-3">
                  <span className="mt-2 h-2 w-2 rounded-full bg-brand" />
                  <span>สำเนาแบบคำขอและเอกสารที่ยื่นตามขอบเขตบริการ</span>
                </li>
                <li className="flex gap-3">
                  <span className="mt-2 h-2 w-2 rounded-full bg-brand" />
                  <span>เอกสารสำหรับเปิดบัญชีธนาคาร หนังสือมอบอำนาจ หรือตรายาง เฉพาะรายการที่ระบุในใบเสนอราคา</span>
                </li>
                <li className="flex gap-3">
                  <span className="mt-2 h-2 w-2 rounded-full bg-brand" />
                  <span>รายการเอกสารที่ควรเตรียมสำหรับเริ่มงานบัญชีรายเดือน</span>
                </li>
              </ul>
            </div>
            <aside className="rounded-2xl border border-brand/20 bg-brand/5 p-6 shadow-soft sm:p-8">
              <h2 className="text-xl font-semibold text-brand">ต้องการประเมินระยะเวลาดำเนินการ?</h2>
              <p className="mt-3 text-base text-gray-700">
                ระยะเวลาดำเนินการขึ้นอยู่กับความครบถ้วนของเอกสาร การอนุมัติชื่อ และขั้นตอนของหน่วยงาน ทีมงานจะแจ้งกรอบเวลาเบื้องต้นหลังตรวจข้อมูล
              </p>
              <p className="mt-4 text-sm text-gray-500">
                หากไม่สะดวกเดินทาง กรุณาแจ้งทีมงานเพื่อตรวจสอบว่าขั้นตอนใดสามารถดำเนินการทางออนไลน์หรือใช้หนังสือมอบอำนาจได้
              </p>
              <a href={lineUrl} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center text-sm font-semibold text-brand">
                พูดคุยกับทีมจดทะเบียน &rarr;
              </a>
            </aside>
          </div>

          <div className="mt-8 rounded-2xl border border-amber-200 bg-amber-50/60 p-6 sm:p-8">
            <h2 className="text-xl font-semibold text-gray-900">เงื่อนไขราคาและค่าใช้จ่ายภายนอก</h2>
            <p className="mt-3 text-sm leading-7 text-gray-700">
              ก่อนเริ่มงาน ทีมงานจะแจ้งเป็นรายการว่าราคาเสนอรวมค่าธรรมเนียมราชการ ค่าอากร ค่ารับรองเอกสาร ตรายาง หรือค่าใช้จ่ายบุคคลภายนอกใดบ้าง เพื่อป้องกันความเข้าใจคลาดเคลื่อน
            </p>
          </div>

          <div id="faq" className="mt-12 rounded-2xl border border-gray-100 p-6 shadow-soft scroll-mt-28 sm:p-8">
            <h2 className="text-2xl font-semibold text-gray-900">คำถามที่พบบ่อย</h2>
            <dl className="mt-6 space-y-6 text-base text-gray-600">
              {faqs.map((faq) => (
                <div key={faq.question}>
                  <dt className="font-semibold text-gray-900">{faq.question}</dt>
                  <dd className="mt-2">{faq.answer}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </section>
    </>
  );
}
